import { createContext, useCallback, useContext, useMemo } from 'react'

import { JourneyScope } from '@cash-web/shared-journey-util-main'

import { JourneyParentContext } from './JourneyParentContext'
import { JourneyContextProps, JourneyNavigate } from './types'

const error = async () => {
  throw Error('JourneyProvider not found')
}
export const JourneyContext = createContext<JourneyContextProps>({
  navigate: error,
  cancel: error,
  cancelAll: error,
  complete: error,
  isInProgress: () => false,
  isFlowLoading: () => false,
  hasParentTarget: () => false,
  matches: () => false,
  preload: () => null,
  loadingRoute: undefined,
})

export function useJourneyContext() {
  const parent = useContext(JourneyParentContext)
  const result = useContext<JourneyContextProps>(JourneyContext)

  const navigate = useCallback<JourneyNavigate>(
    async (path, opts) => await result.navigate(path, { ...(opts ?? {}), parent }),
    [parent, result]
  )

  return useMemo(
    () => ({
      ...result,
      navigate,
    }),
    [result, navigate]
  )
}

export function useJourneyScope(): Partial<JourneyScope> {
  const context = useJourneyContext()

  return context.active?.opts?.scope ?? {}
}
